'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _set = require('babel-runtime/core-js/set');

var _set2 = _interopRequireDefault(_set);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _Extension = require('../Extension');

var _Extension2 = _interopRequireDefault(_Extension);

var _ExtensionAction = require('../ExtensionAction');

var _ExtensionAction2 = _interopRequireDefault(_ExtensionAction);

var _Framework = require('./Framework');

var _Framework2 = _interopRequireDefault(_Framework);

var _FrameworkState = require('./FrameworkState');

var _FrameworkState2 = _interopRequireDefault(_FrameworkState);

var _PluginState = require('../PluginState');

var _PluginState2 = _interopRequireDefault(_PluginState);

var _ServiceAction = require('../ServiceAction');

var _ServiceAction2 = _interopRequireDefault(_ServiceAction);

var _log = require('../utility/log');

var _log2 = _interopRequireDefault(_log);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 事件管理器，用于监听、取消监听、触发事件
 * 
 * @ignore
 * @export
 * @class EventManager
 */
var EventManager = function () {
    /**
     * 创建一个事件管理器
     * 
     * @ignore
     * @memberof EventManager
     */
    function EventManager() {
        (0, _classCallCheck3.default)(this, EventManager);

        this.frameworkStateChangedListeners = new _set2.default();
        this.pluginStateChangedListeners = new _set2.default();
        this.serviceChangedListeners = new _set2.default();
        this.extensionChangedListeners = new _set2.default();

        this.dispose = this.dispose.bind(this);

        this.addPluginStateChangedListener = this.addPluginStateChangedListener.bind(this);
        this.firePluginStateChanged = this.firePluginStateChanged.bind(this);
        this.removePluginStateChangedListener = this.removePluginStateChangedListener.bind(this);

        this.addFrameworkStateChangedListener = this.addFrameworkStateChangedListener.bind(this);
        this.fireFrameworkStateChanged = this.fireFrameworkStateChanged.bind(this);
        this.removeFrameworkStateChangedListener = this.removeFrameworkStateChangedListener.bind(this);

        this.addServiceChangedListener = this.addServiceChangedListener.bind(this);
        this.fireServiceChanged = this.fireServiceChanged.bind(this);
        this.removeServiceChangedListener = this.removeServiceChangedListener.bind(this);

        this.addExtensionChangedListener = this.addExtensionChangedListener.bind(this);
        this.fireExtensionChanged = this.fireExtensionChanged.bind(this);
        this.removeExtensionChangedListener = this.removeExtensionChangedListener.bind(this);
    }

    /**
     * 清理资源
     * 
     * @memberof EventManager
     */


    (0, _createClass3.default)(EventManager, [{
        key: 'dispose',
        value: function dispose() {
            this.frameworkStateChangedListeners.clear();
            this.pluginStateChangedListeners.clear();
            this.serviceChangedListeners.clear();
            this.extensionChangedListeners.clear();
        }

        /**
         * 添加框架状态监听器
         * 
         * @param {function} listener 监听器函数
         * @example 
         * frameworkStateChangedListener(framework, previousState, currentState) {
         *     // ...
         * }
         * @memberof EventManager
         */

    }, {
        key: 'addFrameworkStateChangedListener',
        value: function addFrameworkStateChangedListener(listener) {
            if (!this.frameworkStateChangedListeners.has(listener)) {
                this.frameworkStateChangedListeners.add(listener);
            }
        }

        /**
         * 删除框架状态监听器
         * 
         * @param {function} listener 监听器函数
         * @memberof EventManager
         */

    }, {
        key: 'removeFrameworkStateChangedListener',
        value: function removeFrameworkStateChangedListener(listener) {
            if (this.frameworkStateChangedListeners.has(listener)) {
                this.frameworkStateChangedListeners.delete(listener);
            }
        }

        /**
         * 触发框架状态变更
         * 
         * @param {Framework} framework 框架实例
         * @param {FrameworkState} previousState 前一个状态
         * @param {FrameworkState} currentState 当前状态
         * @memberof EventManager
         */

    }, {
        key: 'fireFrameworkStateChanged',
        value: function fireFrameworkStateChanged(framework, previousState, currentState) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(this.frameworkStateChangedListeners), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var listener = _step.value;

                    try {
                        listener(framework, previousState, currentState);
                    } catch (error) {
                        _log2.default.logger.error('Failed to invoke the frameworkStateChanged listener.', error);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }

        /**
         * 添加插件状态监听器
         * 
         * @param {function} listener 监听器函数
         * @example
         * pluginStateChangedListener(id, previous, current) {
         *     // ...
         * }
         * @memberof EventManager
         */

    }, {
        key: 'addPluginStateChangedListener',
        value: function addPluginStateChangedListener(listener) {
            if (!this.pluginStateChangedListeners.has(listener)) {
                this.pluginStateChangedListeners.add(listener);
            }
        }

        /**
         * 删除插件状态监听器
         * 
         * @param {function} listener 监听器函数 
         * @memberof EventManager
         */

    }, {
        key: 'removePluginStateChangedListener',
        value: function removePluginStateChangedListener(listener) {
            if (this.pluginStateChangedListeners.has(listener)) {
                this.pluginStateChangedListeners.delete(listener);
            }
        }

        /**
         * 触发插件状态变更
         * 
         * @param {string} id 插件Id
         * @param {PluginState} previousState 前一个状态
         * @param {PluginState} currentState 当前状态
         * @memberof EventManager
         */

    }, {
        key: 'firePluginStateChanged',
        value: function firePluginStateChanged(id, previousState, currentState) {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = (0, _getIterator3.default)(this.pluginStateChangedListeners), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var listener = _step2.value;

                    try {
                        listener(id, previousState, currentState);
                    } catch (error) {
                        _log2.default.logger.error('Failed to invoke the pluginStateChanged listener.', error);
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        }

        /**
         * 添加服务变更监听器
         * 
         * @param {function} listener 监听器函数
         * @example 
         * serviceChangedListener(name, action) {
         * }
         * @memberof EventManager
         */

    }, {
        key: 'addServiceChangedListener',
        value: function addServiceChangedListener(listener) {
            if (!this.serviceChangedListeners.has(listener)) {
                this.serviceChangedListeners.add(listener);
            }
        }

        /**
         * 删除服务变更监听器
         * 
         * @param {function} listener 监听器函数
         * @memberof EventManager
         */

    }, {
        key: 'removeServiceChangedListener',
        value: function removeServiceChangedListener(listener) {
            if (this.serviceChangedListeners.has(listener)) {
                this.serviceChangedListeners.delete(listener);
            }
        }

        /**
         * 触发服务变更事件
         * 
         * @param {string} name 服务名称
         * @param {ServiceAction} action 变化活动
         * @memberof EventManager
         */

    }, {
        key: 'fireServiceChanged',
        value: function fireServiceChanged(name, action) {
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = (0, _getIterator3.default)(this.serviceChangedListeners), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var listener = _step3.value;

                    try {
                        listener(name, action);
                    } catch (error) {
                        _log2.default.logger.error('Failed to invoke the serviceChanged listener.', error);
                    }
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }
        }

        /**
         * 添加扩展变更监听器
         * 
         * @param {function} listener 监听器函数
         * @example
         * extensionChangedListener(extension, action) {
         *     // ......
         * }
         * @memberof EventManager
         */

    }, {
        key: 'addExtensionChangedListener',
        value: function addExtensionChangedListener(listener) {
            if (!this.extensionChangedListeners.has(listener)) {
                this.extensionChangedListeners.add(listener);
            }
        }

        /**
         * 删除扩展变更监听器
         * 
         * @param {function} listener 监听器函数
         * @memberof EventManager
         */

    }, {
        key: 'removeExtensionChangedListener',
        value: function removeExtensionChangedListener(listener) {
            if (this.extensionChangedListeners.has(listener)) {
                this.extensionChangedListeners.delete(listener);
            }
        }

        /**
         * 触发扩展变更时间
         * 
         * @param {Extension} extension 扩展对象
         * @param {ExtensionAction} action 变化活动
         * @memberof EventManager
         */

    }, {
        key: 'fireExtensionChanged',
        value: function fireExtensionChanged(extension, action) {
            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
                for (var _iterator4 = (0, _getIterator3.default)(this.extensionChangedListeners), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                    var listener = _step4.value;

                    try {
                        listener(extension, action);
                    } catch (error) {
                        _log2.default.logger.error('Failed to invoke the extensionChanged listener.', error);
                    }
                }
            } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                        _iterator4.return();
                    }
                } finally {
                    if (_didIteratorError4) {
                        throw _iteratorError4;
                    }
                }
            }
        }
    }]);
    return EventManager;
}();

exports.default = EventManager;
//# sourceMappingURL=EventManager.js.map